export namespace AvatarConsts {
  export const fallbackUserName = 'Anonymous';
  export const defaultAvatarSize = '25px';
}

export namespace CircleImageConsts {
  export const defaultSize = '50px';
}
